"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyEmailScreen = void 0;
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const redux_1 = require("@/redux");
const api_payloads_1 = require("@/redux/api-payloads");
const selectors_1 = __importDefault(require("@/selectors"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
class VerifyEmailScreen extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.resendVerificationEmail = () => {
            const { makeRequest, user } = this.props;
            const data = { username: user.username };
            makeRequest(data);
        };
    }
    render() {
        return (react_1.default.createElement("div", { className: styles_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_scss_1.default.leftContainer },
                react_1.default.createElement("div", { className: styles_scss_1.default.formContainer },
                    react_1.default.createElement("h4", { className: styles_scss_1.default.title }, constants_1.default.verifyEmail.verifyEmail),
                    react_1.default.createElement("div", { className: styles_scss_1.default.subtitle }, constants_1.default.verifyEmail.weveSentAnEmailToVerify),
                    react_1.default.createElement(components_1.Button, { type: "button", onClick: this.resendVerificationEmail, ariaLabel: constants_1.default.verifyEmail.resendEmail, title: constants_1.default.verifyEmail.resendEmail, className: styles_scss_1.default.resendButton }))),
            react_1.default.createElement("div", { className: styles_scss_1.default.rightContainer },
                react_1.default.createElement("img", { src: constants_1.Images.loginBackground, alt: constants_1.Images.loginBackground }))));
    }
}
exports.VerifyEmailScreen = VerifyEmailScreen;
const mapStateToProps = (state) => ({
    user: selectors_1.default.user.getUser(state),
});
const mapDispatchToProps = {
    makeRequest: (data) => redux_1.ActionCreators.api.makeRequest.dispatch(api_payloads_1.verifyEmailPayload(data)),
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(VerifyEmailScreen);
